import React from "react";
import { PlanoVinculadoEntidade } from "../../entidades";
import {
  Col,
  Form,
  Box,
  Row,
  CampoTexto,
  Botao,
  TipoBotao,
  TamanhoBotao,
  Alerta,
  TipoAlerta,
} from "@intechprev/componentes-web";
import { FichaFinanceiraService } from "../../services";
import DataInvalida from "../../_utils/Data";
import moment from "moment";

interface Props {
  plano: PlanoVinculadoEntidade;
}

interface State {
  dataInicial: string;
  dataFinal: string;
}

export class PlanoItem extends React.Component<Props, State> {
  private form = React.createRef<Form>();
  private alert = React.createRef<Alerta>();

  state: State = {
    dataInicial: "",
    dataFinal: "",
  };

  componentDidMount = async () => {
    try {
      await this.carregarDatas();
    } catch (err) {
      console.log(err);
    }
  };

  carregarDatas = async () => {
    const datasExtrato = await FichaFinanceiraService.BuscarDatasExtrato(
      this.props.plano.CD_PLANO
    );

    await this.setState({
      dataInicial: datasExtrato.inicial,
      dataFinal: datasExtrato.final,
    });
  };

  gerarExtrato = async () => {
    try {
      await this.alert.current.limparErros();
      await this.form.current.validar();

      var dataInicio = this.converteData("01/" + this.state.dataInicial);
      var dataFim = this.converteData("01/" + this.state.dataFinal);

      await this.validarData(
        "01/" + this.state.dataInicial,
        dataInicio,
        "Data de Início"
      );
      await this.validarData(
        "01/" + this.state.dataFinal,
        dataFim,
        "Data Fim"
      );

      if (dataInicio > dataFim)
        await this.alert.current.adicionarErro(
          "A data inicial não pode ser superior à data final"
        );

      if (dataFim > new Date())
        await this.alert.current.adicionarErro(
          "A data final não pode ser superior à data atual"
        );

      // if(this.alert.current.state.mensagem.length === 0 && this.alert.current.props.mensagem.length === 0) {
      if (await this.alert.current.possuiErro()) {
        var dtInicio = moment(
          "01/" + this.state.dataInicial,
          "DD/MM/YYYY"
        ).format("DD.MM.YYYY");

        var dtFim = moment(
          "01/" + this.state.dataFinal,
          "DD/MM/YYYY"
        ).format("DD.MM.YYYY");

        var relatorio = await FichaFinanceiraService.GerarExtrato(
          this.props.plano.CD_PLANO,
          dtInicio,
          dtFim
        );

        if (navigator.msSaveBlob) {
          // IE10+ : (has Blob, but not a[download] or URL)
          return navigator.msSaveBlob(
            new Blob([relatorio]),
            "Extrato.pdf"
          );
        } else {
          const blobURL = window.URL.createObjectURL(
            new Blob([relatorio])
          );
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", "Extrato.pdf");

          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }

          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
      }
    } catch (erro) {
      if (erro.response) {
        await this.alert.current.adicionarErro(
          await erro.response.data.text()
        );
      } else {
        await this.alert.current.adicionarErro(erro);
      }
    }
  };

  validarData = async (data: string, dataObjeto: Date, nomeCampo: string) => {
    if (DataInvalida(dataObjeto, data))
      await this.alert.current.adicionarErro(
        `Campo "${nomeCampo}" inválido.`
      );
  };

  converteData = (data: any) => {
    var dataObjeto = data.split("/");
    dataObjeto = new Date(dataObjeto[2], dataObjeto[1] - 1, dataObjeto[0]);
    return dataObjeto;
  };

  render() {
    if (
      this.props.plano.CD_CATEGORIA !== "4" &&
      this.props.plano.CD_PLANO !== "0001"
    ) {
      return (
        <Col>
          <Form ref={this.form}>
            <Box
              titulo={this.props.plano.DS_PLANO}
              label={this.props.plano.DS_SIT_PLANO}
              renderRow={false}
            >
              <Row>
                <Col>
                  <h5>Período do Extrato</h5>
                </Col>
              </Row>

              <Row>
                <Col>
                  <CampoTexto
                    contexto={this}
                    nome={"dataInicial"}
                    mascara={"99/9999"}
                    obrigatorio
                    valor={this.state.dataInicial}
                    titulo={"Data de Início"}
                    placeholder={"MM/AAAA"}
                    tamanhoTitulo={"lg-3"}
                  />

                  <CampoTexto
                    contexto={this}
                    nome={"dataFinal"}
                    mascara={"99/9999"}
                    obrigatorio
                    valor={this.state.dataFinal}
                    titulo={"Data Final"}
                    placeholder={"MM/AAAA"}
                    tamanhoTitulo={"lg-3"}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Botao
                    tipo={TipoBotao.primary}
                    tamanho={TamanhoBotao.pequeno}
                    titulo={
                      "Baixar Extrato de Contribuições"
                    }
                    onClick={this.gerarExtrato}
                    usaLoading={true}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Alerta
                    ref={this.alert}
                    tipo={TipoAlerta.danger}
                    className={"mt-2"}
                  />
                </Col>
              </Row>
            </Box>
          </Form>
        </Col>
      );
    } else {
      return (
        <Col>
          <Box
            titulo={this.props.plano.DS_PLANO}
            label={this.props.plano.DS_SIT_PLANO}
            renderRow={false}
          >
            <Alerta
              tipo={TipoAlerta.danger}
              mensagem={
                "Nenhum extrato disponível para esse plano."
              }
            />
          </Box>
        </Col>
      );
    }
  }
}
